import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../instance';

const initialState = {
	saving: false, 
	uploading:false,
};

// const url = process.env.REACT_APP_API_BASE_URL;


export const save = createAsyncThunk('saveSlice/save/ordinary', async (data, { rejectWithValue }) => {
	let saveUrl = data.url;
	delete data.url;
	await new Promise((resolve) => setTimeout(resolve, 0));
	try {
		const response = await axiosInstance.post(`/${saveUrl}`, data)
		if (response.data._unauthorized) return { success: false, _unauthorized: true };
		if (!response.data.success) {
			return rejectWithValue(response.data);
		}
		return response.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { success: false, message: error.message });
	}
  });

  export const saveFile = createAsyncThunk('saveSlice/saveFile', async (data) => {
	await new Promise((resolve) => setTimeout(resolve, 0)); 
	const res = await axiosInstance
		.post(`/file/save_file`, data, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		})
		.then((res) => res.data);
	return res;
});

export const uploadFile = createAsyncThunk('saveSlice/uploadFile', async (data) => {
	await new Promise((resolve) => setTimeout(resolve, 0)); 
	const res = await axiosInstance
		.post(`/api/v2/projectFiles/uploadFile`, data, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		})
		.then((res) => res.data);
	return res;
});


 export const saveFlat = createAsyncThunk('saveSlice/save/saveFlat', async (data, { rejectWithValue }) => {
	let saveUrl = data.url;
	delete data.url;
	await new Promise((resolve) => setTimeout(resolve, 0));
	try {
		const response = await axiosInstance.post(`/${saveUrl}`, data.data)
		if (response.data._unauthorized) return { success: false, _unauthorized: true };
		if (!response.data.success) {
			return rejectWithValue(response.data);
		}
		return response.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || { success: false, message: error.message });
	}
  });

 
export const saveSlice = createSlice({
	name: 'save',
	initialState,
	reducers: {
		clearSaveObj: () => {
            return { ...initialState };
        },
	},
	extraReducers: (builder) => {
		builder
			 
			.addCase(save.pending, (state) => {
				state.saving = true;
			})
			.addCase(save.fulfilled, (state) => {
				state.saving = false;
			})
			.addCase(save.rejected, (state) => {
				state.saving = false;
			}) 
			
			.addCase(saveFile.pending, (state) => {
				state.saving = true;
			})
			.addCase(saveFile.fulfilled, (state, action) => {
				state.saving = false;
			})
			.addCase(saveFile.rejected, (state) => {
				state.saving = false;
			})
 
			.addCase(uploadFile.pending, (state) => {
				state.uploading = true;
			})
			.addCase(uploadFile.fulfilled, (state, action) => {
				state.uploading = false;
			})
			.addCase(uploadFile.rejected, (state) => {
				state.uploading = false;
			})

			.addCase(saveFlat.pending, (state) => {
				state.saving = true;
			})
			.addCase(saveFlat.fulfilled, (state) => {
				state.saving = false;
			})
			.addCase(saveFlat.rejected, (state) => {
				state.saving = false;
			}) 
			
	},
});

export default saveSlice.reducer;
export const {clearSaveObj} = saveSlice.actions;
